import { EndpointError } from '@square/ignition';
import { Box, CodeField, Paragraph10 } from '@squareup/dex-ui-shared-base';
import { getHttpCodeDescription } from '@squareup/dex-utils-error';
import React, { FunctionComponent } from 'react';

import styles from './error-info.module.css';

interface ErrorInfoProps {
  errorProperty: EndpointError;
}

/**
 */
const ErrorInfo: FunctionComponent<ErrorInfoProps> = ({ errorProperty }) => {
  return (
    <div className={styles['error-property-info']}>
      <Box>
        <Box>
          <CodeField weight={'medium'}>
            {errorProperty.httpCode
              ? errorProperty.httpCode
              : errorProperty.name}
          </CodeField>
        </Box>
      </Box>
      {
        <Box margin={{ bottom: '1x' }}>
          <Paragraph10 colorVariant={'20'}>
            {getHttpCodeDescription(errorProperty)}
          </Paragraph10>
        </Box>
      }
    </div>
  );
};

export { ErrorInfo };
